import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  CUSTOMER,
  COMPANY,
  DROPSHIP,
  REPAIR_STATION
} from "MODULES/shared/components/ShippingSection/shippingTypes";

export function validateShippingFields(shippingType, values, form) {
  const shipToType = values[`${shippingType}_type`];
  form.validate(`${shippingType}_type`).satisfies(rules.required);

  if (shipToType === COMPANY) {
    form
      .validate(
        `${shippingType}_company_id`,
        `${shippingType}_company_address_id`
      )
      .satisfies(rules.required);
  } else if (shipToType === DROPSHIP) {
    form.validateChild(`${shippingType}_shipping_address`, address => {
      address
        .validate("country", "line1", "city", "postal_code")
        .satisfies(rules.required);
    });
  } else if (shipToType === CUSTOMER) {
    form
      .validate(`${shippingType}_customer_address_id`)
      .satisfies(rules.required);
  } else if (shipToType === REPAIR_STATION) {
    form
      .validate("repair_station_physical_address_id")
      .satisfies(rules.required);
  }
}

export function validateForShippingType(shippingType) {
  return values =>
    validator(values, form => {
      validateShippingFields(shippingType, values, form);
    });
}

export default function(values) {
  return validator(values, form => {
    validateShippingFields("ship_to", values, form);
  });
}



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/ShippingSection/validate.js